{
  "hero": {
    "title": "Soluzioni Energy-Fintech",
    "highlight": "per la transizione energetica",
    "subtitle": "Ridefiniamo il modo in cui si consuma e produce energia rinnovabile. Scopri le nostre soluzioni per aziende e produttori."
  },
  "fork": {
    "companies": {
      "title": "Per le aziende",
      "desc": "Senza venderti energia, abbassiamo i tuoi costi energetici mentre eleviamo la tua sostenibilità.",
      "ctaShort": "Vai alle soluzioni"
    },
    "producers": {
      "title": "Per i produttori",
      "desc": "Senza vendere i tuoi impianti o contrarre ulteriore debito, ottieni cassa immediata e derisking.",
      "ctaShort": "Vai alle soluzioni"
    },
    "capital": {
      "title": "Per gli investitori",
      "desc": "Compra quote di ricavi da impianti rinnovabili già in esercizio, senza acquistare gli asset.",
      "ctaShort": "Scopri DEC Capital"
    }
  }
}
